import { Splash } from 'components/Splash'
import { useEffect, useState } from 'react'
import feathers from 'utility/client'

export const AuthGate = (props) => {
  const [authReady, setAuthReady] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      feathers.get('authentication').then(() => {
        setAuthReady(true)
        clearInterval(interval)
      }).catch(() => console.log('Waiting for re-authentication'))
    }, 1000)
  }, [])

  return (
    authReady ? props.children : <Splash />
  )
}
